import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { createContext, useState, useContext } from "react";
import { useGetStudentDetailsMutation } from "../../apiSlice";

// creating the context
const ParentalInfoCheckContext = createContext();

// creating a provider function
export function ParentalInfoCheck({ children }) {
    const location = useLocation();
    const [isParentInfoPresent, setIsParentInfoPresent] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const [studentDetailsAPI] = useGetStudentDetailsMutation();

    // Taking path name from the `url`
    const pathName = location.pathname.replace("/", "");

    useEffect(() => {
        const fetchStudentData = async () => {
            try {
                // Simulate API call
                const studentDetails = await studentDetailsAPI();

                if (studentDetails !== null) {
                    const data = studentDetails.data[0];

                    if (
                        data?.fatherName === "" ||
                        data?.fatherName === null ||
                        data?.father_Phone_Number === "" ||
                        data?.father_Phone_Number === null ||
                        data?.motherName === "" ||
                        data?.motherName === null ||
                        data?.mother_Phone_Number === "" ||
                        data?.mother_Phone_Number === null
                    ) {
                        setIsParentInfoPresent(false);
                        console.log("isParentInfoPresent", isParentInfoPresent);
                    } else {
                        setIsParentInfoPresent(true);
                        console.log("isParentInfoPresent", isParentInfoPresent);
                    }
                }
            } catch (error) {
                console.error("Error fetching student data:", error);
            }
        };

        /**
         * if the page is "/login" then this function won't work because the
         * API won't call and will go in a `Infinite Loop`
         * 
         * So added a check, where if the page is `/login` then this function 
         * won't be called.
         */
        if (pathName !== "login") {
            fetchStudentData();
        }
    }, [pathName]);

    return (
        <ParentalInfoCheckContext.Provider
            value={{ isParentInfoPresent, snackbarOpen, setSnackbarOpen }}
        >
            {children}
        </ParentalInfoCheckContext.Provider>
    );
}

export function useParentalInfoCheck() {
    const context = useContext(ParentalInfoCheckContext);

    if (!context) {
        throw new Error(
            "useParentInfoCheck must be used within a ParentInfoCheckContext Provider"
        );
    }

    return context;
}
